module.exports = __webpack_public_path__ + "static/media/icon-pending-tab.f5256a02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-pending-tab.svg
// module id = 952
// module chunks = 0